import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { TOPIC_LINKS } from "@/pages/seo/seoContent";

const renderItem = ({ to, label, note }: (typeof TOPIC_LINKS)[number]) => (
  <li key={to}>
    <Link to={to} className="group flex flex-col gap-1 py-4 sm:flex-row sm:items-baseline sm:gap-6">
      <span className="text-[15.5px] font-medium text-foreground sm:w-[15rem] sm:shrink-0">{label}</span>
      <span className="text-[14px] text-muted-foreground leading-[1.65] group-hover:text-foreground/80 transition-colors">
        {note}
      </span>
    </Link>
  </li>
);

/**
 * Themeneinstiege der Website. Erste drei sichtbar, Rest aufklappbar.
 */
export function ThemenSection() {
  return (
    <section id="themen" aria-label="Liftthemen" className="bg-background border-t border-border scroll-mt-16">
      <div className="max-w-3xl mx-auto px-6 py-14 sm:py-16">
        <h2 className="text-[20px] sm:text-[23px] font-semibold tracking-[-0.02em] text-foreground">
          Informationen zu Ihrem Liftprojekt.
        </h2>
        <p className="mt-3 text-[15px] text-muted-foreground leading-[1.7] max-w-[62ch]">
          Kosten, Planung, Nachrüstung, Wartung und Modernisierung: die wichtigsten Themen kurz erklärt, bevor Sie Ihre Anfrage erfassen.
        </p>

        <ul className="mt-8 divide-y divide-border border-y border-border">
          {TOPIC_LINKS.slice(0, 3).map(renderItem)}
        </ul>

        {TOPIC_LINKS.length > 3 && (
          <details className="group/more">
            <summary className="flex cursor-pointer list-none items-center justify-center gap-2 border-b border-border py-4 text-[14.5px] font-medium text-foreground hover:bg-muted/40 transition-colors [&::-webkit-details-marker]:hidden">
              <span className="group-open/more:hidden">Alle {TOPIC_LINKS.length} Themen anzeigen</span>
              <span className="hidden group-open/more:inline">Weniger anzeigen</span>
              <ChevronDown className="h-4 w-4 transition-transform group-open/more:rotate-180" />
            </summary>
            <ul className="divide-y divide-border border-b border-border">
              {TOPIC_LINKS.slice(3).map(renderItem)}
            </ul>
          </details>
        )}
      </div>
    </section>
  );
}
